import React, { useEffect, useState, useCallback } from 'react';
import { useHistory } from 'react-router-dom';

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  CircularProgress,
  TableFooter,
  TablePagination,
} from '@material-ui/core';
import { Container, Typography, Divider } from '@material-ui/core/';

import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import { useStyles } from './styles';
import api from '../../services/api';
import { FlagsResponseType } from '../../@types/records';
import Colors from '../../components/Colors';

const initialRecordsResponse: FlagsResponseType = {
  count: 0,
  next: '',
  previous: '',
  results: [],
};

const Review: React.FC = () => {
  const classes = useStyles();
  const [loading, setLoading] = useState<boolean>(true);
  const [records, setRecords] = useState<FlagsResponseType>(initialRecordsResponse);
  const [tablePage, setTablePage] = useState<number>(0);
  const [rowsPerPage, setRowsPerPage] = useState<number>(25);
  const [pageOffset, setPageOffset] = useState<number>(0);

  const [admin, setAdmin] = useState<boolean>(false);
  const [typist, setTypist] = useState<boolean>(false);
  const [tecEng, setTecEng] = useState<boolean>(false);
  const [geofi, setGeofi] = useState<boolean>(false);
  const [publicGroup, setPublicGroup] = useState<boolean>(false);
  const history = useHistory();

  useEffect(() => {
    const groups = localStorage.getItem('groups')?.split(' ');
    if (groups) {
      groups.forEach((gr: string) => {
        if (gr === 'public') {
          setPublicGroup(true);
        } else if (gr === 'digitador') {
          setTypist(true);
        } else if (gr === 'tec_engenharia') {
          setTecEng(true);
        } else if (gr === 'geofi') {
          setGeofi(true);
        } else if (gr === 'admin') {
          setAdmin(true);
        }
      });
    }
  }, []);

  if ((tecEng || geofi || publicGroup) && !(admin || typist)) {
    history.push('/mapa/sinistros');
  }

  const navigate = (pathId: string) => {
    history.push(pathId);
  };

  const fetchData = useCallback(async () => {
    setLoading(true);
    const { data } = await api.get<FlagsResponseType>('/api/record-flag/', {
      headers: { Authorization: `Token ${localStorage.getItem('auth')}` },
      params: {
        archived: 'False',
        details_only: 'True',
        limit: rowsPerPage,
        offset: pageOffset,
      },
    });

    setRecords(data);
    setLoading(false);
  }, [rowsPerPage, pageOffset]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleChangePage = (event: unknown, newPage: number) => {
    newPage < tablePage
    ? setPageOffset((prev) => prev - rowsPerPage)
    : setPageOffset((prev) => prev + rowsPerPage);

    setTablePage(newPage);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPageOffset(0);
    setTablePage(0);
  };

  return (
    <>
      {loading ? (
        <div className={classes.loadingContainer}>
          <CircularProgress className={classes.loadingSpinner} size={60} thickness={5} />
        </div>
      ) : (
        <>
          <Container className={classes.container}>
            <Typography variant="h5" gutterBottom style={{ marginTop: '2%' }}>
              Revisão
            </Typography>
            <Divider />
            <TableContainer className={classes.tableContainer}>
              <Table className={classes.table}>
                <TableHead className={classes.tableHead}>
                  <TableRow>
                    <TableCell style={{color: Colors.tertiary}}>Descrição</TableCell>
                    <TableCell style={{color: Colors.tertiary}} className={classes.responsive}>Data e Hora</TableCell>
                    <TableCell style={{color: Colors.tertiary}} className={classes.responsive}>Endereço 1</TableCell>
                    <TableCell style={{color: Colors.tertiary}} className={classes.responsive}>Endereço 2</TableCell>
                    <TableCell style={{color: Colors.tertiary}}>Funções</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {records.results.map((value) => (
                    <TableRow key={value.uuid} hover>
                      <TableCell width={300}>{value.description}</TableCell>
                      <TableCell className={classes.responsive}>
                        {`${format(new Date(value.datetime), 'dd MMMM, yyyy, HH:mm', {
            locale: ptBR,
          })}`}
                      </TableCell>
                      <TableCell width={300} className={classes.responsive}>
                        {value.address_1}
                      </TableCell>
                      <TableCell className={classes.responsive}>
                        {value.address_2}
                      </TableCell>
                      <TableCell className={classes.buttonsCol}>
                        <Button
                          size="small"
                          variant="outlined"
                          className={classes.button}
                        >
                          Editar
                        </Button>
                        <Button
                          size="small"
                          variant="outlined"
                          className={classes.button}
                          onClick={() =>
            navigate(`/registro/sinistros/${value.record_uuid}`)}
                        >
                          Exibir
                        </Button>
                      </TableCell>
                    </TableRow>
            ))}
                </TableBody>
                <TableFooter>
                  <TableRow>
                    <TablePagination
                      rowsPerPageOptions={[25, 50]}
                      rowsPerPage={rowsPerPage}
                      count={records.count}
                      page={tablePage}
                      SelectProps={{
              inputProps: { 'aria-label': 'rows per page' },
            }}
                      labelRowsPerPage={<span>Linhas por página</span>}
                      labelDisplayedRows={({ from, to, count }) =>
            `${from}-${to} de ${count}`}
                      onChangePage={handleChangePage}
                      onChangeRowsPerPage={handleChangeRowsPerPage}
                    />
                  </TableRow>
                </TableFooter>
              </Table>
            </TableContainer>
          </Container>
        </>
            )}
    </>
            );
          };

          export default Review;
